<div fxLayout="column" fxLayoutAlign="center center" class="min-width-w">
  <mat-form-field class="mat-form-field" [formGroup]="Form">
    <input matInput type="text" [placeholder]="Title" [ngClass]="Disable ? 'field-input-disabled' : 'field-input'"
      formControlName="Field" [@blinkError]="blinkAnimErr ? 'red' : 'normal'" (input)="onTextChange()"
      autocomplete="off" [matTooltip]="FormError">
  </mat-form-field>
  <div *ngIf="RealValue != undefined  && !Disable" class="aro-label-under-input"
    [matTooltip]="'FIELDS.CURRENT_VALUE' | translate">
    {{RearDecor}}{{RealValue}}{{FrontDecor}}
  </div>
  <div *ngIf="Comment != undefined"
    [ngClass]="Disable ? 'aro-label-under-input-clickable-disabled' : 'aro-label-under-input'">{{Comment}}
  </div>
</div>